// src/utils/emailUtils.ts
import logger from "./logger";

export interface EmailParams {
  to: string[];
  subject: string;
  html?: string;
  text?: string;
  attachments?: Array<{ filename: string; content: string; type?: string }>;
}

/**
 * Sends an email using the Resend API.
 * @param params Email parameters
 * @returns Promise<void>
 */
export async function sendEmail(params: EmailParams): Promise<void> {
  // console.log("Sending email with params:", params);
  // console.log(process.env.REACT_APP_RESEND_API_KEY);

  const RESEND_API_KEY = process.env.REACT_APP_RESEND_API_KEY;
  const RESEND_FROM_EMAIL = process.env.REACT_APP_RESEND_FROM_EMAIL || 'noreply@mindtechinc.com';
  if (!RESEND_API_KEY) throw new Error('Resend API key not set');

  // console.log("1");

  const data: any = {
    from: RESEND_FROM_EMAIL,
    to: params.to,
    subject: params.subject,
    html: params.html,
    text: params.text,
  };

  if (params.attachments) {
    data.attachments = params.attachments;
  }

  // console.log("2");

  try {
    const response = await fetch('https://api.resend.com/emails', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${RESEND_API_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      logger.error('Email send error:', errorData || response.statusText);
      throw new Error(errorData?.message || response.statusText || 'Failed to send email');
    }
  } catch (err: any) {
    logger.error('Email send error:', err?.message || err);
    throw new Error(err?.message || 'Failed to send email');
  }
}
